import React from "react";
import Profile from "../../assets/image/profile-logo.png";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import "../Home/Home.css";

export const Home = () => {
  return (
    <Container
      id="home"
      fluid
      className="d-flex align-items-center justify-content-center min-vh-100 bg-dark text-white p-4 home-container"
    >
      <Row className="w-100">
        <Col md={4} className="d-flex justify-content-center">
          <Image
            src={Profile}
            alt="Profile"
            rounded
            className="shadow-lg img-fluid"
          />
        </Col>
        <Col md={8} className="text-center text-md-start mt-4 mt-md-0 p-4">
          <h1 className="display-1 fw-bold mb-4">Welcome to My Portfolio</h1>
          <motion.p
            className="fs-2"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Hi, I'm <strong>Mr. Parth Panchal</strong>, a passionate{" "}
            <strong>Web Developer</strong> with experience in Multiple
            Languages. I specialize in <strong>React Framework</strong>. Explore
            my work and feel free to connect with me!
          </motion.p>
        </Col>
      </Row>
    </Container>
  );
};
export default Home;
